import React, { memo, useContext, useEffect, useState } from "react";
import Helpers from "../../utils/Helpers";
import classes from "./InstagramFeed.module.css";
import { images } from "../../assets/img";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import useCheckIsMobile from "../../hook/useCheckIsMobile";
import RemoteConfig from "../../services/RemoteConfig";
import AuthContext from "../../store/auth-context";

const MOCK_LOCAL_DATA = {
  0: [
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nail1,
    },
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nail2,
    },
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nailImg03,
    },
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nailImg04,
    },
  ],
  1: [
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nailImg05,
    },
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nail6,
    },
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nail7,
    },
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nail8,
    },
  ],
};
const MOBILE_MOCK_DATA = {
  0: [
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nail1,
    },
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nail2,
    },
  ],
  1: [
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nailImg03,
    },
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nailImg04,
    },
  ],
  2: [
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nailImg05,
    },
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nail6,
    },
  ],
  3: [
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nail7,
    },
    {
      permalink: "https://www.instagram.com/castle_nails_bar/",
      mediaUrl: images.nail8,
    },
  ],
};

const ACCESS_TOKEN =
  "IGQWRPajJLeFNXcWs2R3NjV1RnZAnRUZAjhGRlV5WW1PS2dlYUgxc2NVOTlXcHI3TVBzSUNlN2xoZA0FNMmZAyQXdKNEVTQ3doc2VkeDZA1QTJFVlBzclh4Qkg1S3RhVHNEVWlPd3lwRFRXYzk5NmI4T2RKN1ctLVUwRnMZD";
const USER_ID = "24125941530353577";
const MAXIMUM_IMAGES_FETCHED = 8;

const InstagramFeed = () => {
  const isMobile = useCheckIsMobile();
  const [instagramFeed, setInstagramFeed] = useState(
    isMobile ? MOBILE_MOCK_DATA : MOCK_LOCAL_DATA
  );
  const NUMBER_ITEMS_PER_ROW = isMobile ? 2 : 4;
  const { isFetchActivateRemoteConfig } = useContext(AuthContext);

  useEffect(() => {
    const fetchedConfigImg = RemoteConfig.getConfigValue("instagram_images");
    let instaImg = [];

    for (let i = 0; i < fetchedConfigImg.length; i++) {
      const stringValue = fetchedConfigImg[i];
      const resultObject = { mediaUrl: stringValue };
      instaImg.push(resultObject);
    }

    if (instaImg && Array.isArray(instaImg) && instaImg.length > 0) {
      setInstagramFeed(splitArrayIntoGroup(instaImg));
    }
  }, [isFetchActivateRemoteConfig]);

  useEffect(() => {
    const fetchMedia = async (id) => {
      const mediaUrl = `https://graph.instagram.com/${id}?access_token=${ACCESS_TOKEN}&fields=media_url,permalink`;
      const res = await fetch(mediaUrl);
      const json = await res?.json();
      return { permalink: json?.permalink, mediaUrl: json?.media_url };
    };

    const doFetch = async () => {
      const res = await fetch(
        `https://graph.instagram.com/${USER_ID}/media?access_token=${ACCESS_TOKEN}`
      );
      const json = (await res?.json())?.data;

      const fetchedItems = [];
      if (json?.length > 0) {
        for (
          let i = 0;
          i < json?.length && fetchedItems.length < MAXIMUM_IMAGES_FETCHED;
          i++
        ) {
          const item = json[i];
          const itemId = item.id;
          const instaItem = await fetchMedia(itemId);

          if (!instaItem.mediaUrl.includes("video")) {
            fetchedItems.push(instaItem);
          }
        }

        //Split array into group of NUMBER_ITEMS_PER_ROW
        const grouped = splitArrayIntoGroup(fetchedItems);

        setInstagramFeed(grouped);
      }
    };

    // NOTE: PREVENT FETCHING ON DEV, REMOVE CONDITION TO SEE THE LOGIC RUN
    //TODO: UNCOMMENT THESE 3 LINES TO FETCH IMG FROM INSTAGRAM ELSE USE LOCAL IMG
    // if (!Helpers.isDev) {
    //   doFetch();
    // }
  }, [NUMBER_ITEMS_PER_ROW]);

  const splitArrayIntoGroup = (imgArray) => {
    return imgArray.reduce((acc, post, ind) => {
      const index = parseInt(ind / NUMBER_ITEMS_PER_ROW);
      acc[index] = acc[index] || [];
      acc[index].push(post);
      return acc;
    }, {});
  };

  if (!instagramFeed) {
    return null;
  }

  const openInstagram = () => {
    window.open(NAIL_SHOP_INFO.instagram, "_blank");
  };

  return (
    <div className={classes.container}>
      <div className={classes.instaIconContainer} onClick={openInstagram}>
        <img
          src={images.instaIcon}
          alt={"instagram-icon"}
          className={classes.instaIcon}
        />
        <h3>luxurynailsspa_anniesland</h3>
      </div>

      {!!instagramFeed &&
        Object.keys(instagramFeed).map((row, index) => {
          return (
            <div
              key={index}
              className={`${classes.feedContainer} ${
                index === (isMobile ? 0 : 1) ? classes.noMargin : ""
              }`}
            >
              {Helpers.isArrayAvailable(instagramFeed[row])
                ? instagramFeed[row].map((item, index2) => {
                  console.log('aisudfghdsf',item,index2);
                  
              
                    return (
                      <img
                        key={`${index2}_${item?.mediaUrl?.toString()}`}
                        onClick={() => window.open(item?.permalink, "_blank")}
                        className={`${classes.feedImage}`}
                        alt={item?.mediaUrl?.toString()}
                        src={item?.mediaUrl}
                      />
                    );
                  })
                : null}
            </div>
          );
        })}

      <div onClick={openInstagram} className={classes.followMeContainer}>
        <img
          alt={"instagram-icon"}
          src={images.instaIcon}
          className={classes.instaIconSmall}
        />
        <h4>Follow us on Instagram</h4>
      </div>
    </div>
  );
};

export default memo(InstagramFeed);
